var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryList } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
var ContactComponent = /** @class */ (function () {
    function ContactComponent(util, router, apiService) {
        this.util = util;
        this.router = router;
        this.apiService = apiService;
        this.selectedSms = "";
        this.smsText = "";
        this.submittedSms = false;
        this.selectedEmail = "";
        this.emailText = "";
        this.submittedEmail = false;
        this.attachments = "";
        this.isCheckedAll = false;
        this.confirmMergeList = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: ""
        };
        this.firstnameSearch = "";
        this.lastnameSearch = "";
        this.telephoneSearch = "";
        this.idcardSearch = "";
        this.accountNoSearch = "";
        this.contact1 = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: ""
        };
        this.contact2 = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: ""
        };
        this.chkMain = 1;
        this.chkName = 1;
        this.chkLastname = 1;
        this.chkDob = 1;
        this.chkIdNo = 1;
        this.chkEmail = 1;
        this.chkTel = 1;
        this.dtCon = null;
        this.role = {};
        this.isCrisis = true;
        this.idCard = "";
        this.telephoneNo = "";
    }
    ContactComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        this.util.InitValidation();
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.isCrisis = this.cookieData.isCrisis;
                        return [4 /*yield*/, this.callApi()];
                    case 1:
                        _a.sent();
                        try {
                            $('#summernote').summernote({
                                placeholder: '',
                                tabsize: 2,
                                height: 120,
                                toolbar: [
                                    ['style', ['style']],
                                    ['font', ['bold', 'underline', 'clear']],
                                    ['color', ['color']],
                                    ['para', ['ul', 'ol', 'paragraph']],
                                    ['table', ['table']],
                                    ['insert', ['link', 'picture', 'video']],
                                    ['view', ['fullscreen', 'codeview', 'help']]
                                ]
                            });
                        }
                        catch (e) {
                            this.util.ShowWaiting(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.callApi = function () {
        var _this = this;
        Observable.forkJoin(this.apiService.get("master", "externalSmsTemplate"), this.apiService.get("master", "externalEmailTemplate")).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.smsTemplate = data[0];
                this.emailTemplate = data[1];
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        }); }, function (err) {
            console.error(err);
            _this.util.ShowWaiting(false);
        });
    };
    ContactComponent.prototype.clearActionActive = function () {
        $(".action-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    ContactComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
        this.clearActionActive();
    };
    ContactComponent.prototype.newContact = function (event) {
        var url = this.util.baseUrl() + "/newContact";
        window.open(url, '_blank');
    };
    ContactComponent.prototype.delete = function (event) {
        this.getSelectedContact();
        if (this.selectList.length < 1) {
            this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
        }
        else {
            this.clearActionActive();
            event.target.classList.add("active");
            $("#deleteModal").modal('show');
        }
    };
    ContactComponent.prototype.merge = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var c;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.getSelectedContact();
                        if (!(this.selectList.length != 2)) return [3 /*break*/, 1];
                        this.util.WarningDialog("กรุณาเลือก 2 รายการ");
                        return [3 /*break*/, 4];
                    case 1:
                        this.util.ShowWaiting(true);
                        c = void 0;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[0].contactId)];
                    case 2:
                        c = _a.sent();
                        this.contact1 = c[0];
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[1].contactId)];
                    case 3:
                        c = _a.sent();
                        this.contact2 = c[0];
                        if (this.contact1 == null && this.contact2 == null) {
                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการดึงข้อมูล Contact");
                        }
                        else {
                            this.contact1.dob = this.contact1.birthdate;
                            this.contact2.dob = this.contact2.birthdate;
                            this.mainChange(1);
                            this.clearActionActive();
                            event.target.classList.add("active");
                            $("#mergeModal").modal('show');
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.sms = function (event) {
        var _this = this;
        this.getSelectedContact();
        if (this.selectList.length < 1) {
            this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
        }
        else {
            var invalidTelNo = this.selectList.filter(function (s) {
                return s.tel == null || !_this.util.isValidTelNo(s.tel);
            });
            if (invalidTelNo != null && invalidTelNo.length > 0) {
                this.util.WarningDialog("กรุณาเลือกรายการที่เบอร์มือถือ ถูกต้องเท่านั้น");
            }
            else {
                this.clearActionActive();
                event.target.classList.add("active");
                this.selectedSms = "";
                this.smsText = "";
                this.submittedSms = false;
                $("#smsModal").modal('show');
            }
        }
    };
    ContactComponent.prototype.email = function (event) {
        var _this = this;
        this.getSelectedContact();
        if (this.selectList.length < 1) {
            this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
        }
        else {
            var invalidEmail = this.selectList.filter(function (s) {
                return s.email == null || !_this.util.isValidEmail(s.email);
            });
            if (invalidEmail != null && invalidEmail.length > 0) {
                this.util.WarningDialog("กรุณาเลือกรายการที่ Email ถูกต้องเท่านั้น");
            }
            else {
                this.clearActionActive();
                event.target.classList.add("active");
                this.selectedEmail = "";
                this.emailText = "";
                this.attachments = "";
                this.submittedEmail = false;
                $('#summernote').summernote('code', '');
                $("#emailModal").modal('show');
            }
        }
    };
    ContactComponent.prototype.beforeConfirmMerge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                this.util.ShowWaiting(true);
                req = this.chkMain == 1 ? this.contact1 : this.contact2;
                req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname;
                req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname;
                req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate;
                req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard;
                req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1;
                req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1;
                req.dpa_modifiedby = this.cookieData.userId;
                this.confirmMergeList = req;
                $("#mergeConfirmModal").modal('show');
                $("#mergeModal").modal('hide');
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    ContactComponent.prototype.confirmMerge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        req = this.chkMain == 1 ? this.contact1 : this.contact2;
                        req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname;
                        req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname;
                        req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate;
                        req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard;
                        req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1;
                        req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1;
                        req.dpa_modifiedby = this.cookieData.userId;
                        return [4 /*yield*/, this.apiService.put("crmservice", "contact-merge/" + this.contact1.contactid + "/" + this.contact2.contactid, req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            //await this.search(true)
                            $('#tbContact').DataTable().clear().destroy();
                            $("#mergeConfirmModal").modal('hide');
                            this.util.SuccessDialog("Merge conatct สำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("Merge conatct ไม่สำเร็จ");
                        }
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.confirmSMS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, i, contactId, tel, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedSms = true;
                        if (!(this.selectedSms != "")) return [3 /*break*/, 5];
                        this.util.ShowWaiting(true);
                        success = 0, fail = 0;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectList.length)) return [3 /*break*/, 4];
                        contactId = this.selectList[i].contactId;
                        tel = this.selectList[i].tel;
                        req = {
                            contactid: contactId,
                            dpa_description: "",
                            dpa_phoneno: tel,
                            template: this.selectedSms,
                            dpa_createdby: this.cookieData.userId
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendSms", req)];
                    case 2:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            ++success;
                        }
                        else {
                            ++fail;
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.util.ShowWaiting(false);
                        //some case fail some case success
                        if (fail > 0 && success > 0) {
                            this.util.WarningDialog("ส่ง SMS สำเร็จจำนวน: " + success + " Contact, ส่ง SMS ไม่สำเร็จจำนวน: " + fail + " Contact");
                            $("#smsModal").modal('hide');
                        }
                        else if (fail == 0 && success == 0) {
                            this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ");
                        }
                        else if (fail > 0 && success == 0) {
                            this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ");
                        }
                        else {
                            this.util.SuccessDialog("ส่ง SMS สำเร็จ");
                            $("#smsModal").modal('hide');
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.confirmEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, i, contactId, email, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedEmail = true;
                        if (!(this.selectedEmail != "")) return [3 /*break*/, 5];
                        this.util.ShowWaiting(true);
                        success = 0, fail = 0;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectList.length)) return [3 /*break*/, 4];
                        contactId = this.selectList[i].contactId;
                        email = this.selectList[i].email;
                        req = {
                            contactid: contactId,
                            dpa_name: "",
                            dpa_description: $('#summernote').summernote('code'),
                            //dpa_emailaddress: email,
                            //template: this.selectedEmail,
                            dpa_casesubtypedetailid: null,
                            dpa_createdby: this.cookieData.userId,
                            dpa_customwebuserid: this.cookieData.userId,
                            dpa_callby: 1
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmail2", req)];
                    case 2:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            ++success;
                        }
                        else {
                            ++fail;
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.util.ShowWaiting(false);
                        //some case fail some case success
                        if (fail > 0 && success > 0) {
                            this.util.WarningDialog("ส่ง Email สำเร็จจำนวน: " + success + " Contact, ส่ง Email ไม่สำเร็จจำนวน: " + fail + " Contact");
                            $("#emailModal").modal('hide');
                        }
                        else if (fail == 0 && success == 0) {
                            this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ");
                        }
                        else if (fail > 0 && success == 0) {
                            this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ");
                        }
                        else {
                            this.util.SuccessDialog("ส่ง Email สำเร็จ");
                            $("#emailModal").modal('hide');
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.confirmDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, _loop_1, this_1, res, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        success = 0, fail = 0;
                        _loop_1 = function (i) {
                            var contactId, req;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        contactId = this_1.selectList[i].contactId;
                                        req = this_1.contactList.filter(function (c) {
                                            return c.contactid == contactId;
                                        });
                                        req[0].dpa_modifiedby = this_1.cookieData.userId,
                                            req[0].statusreason = 2;
                                        return [4 /*yield*/, this_1.apiService.put("crmservice", "contact/" + contactId, req[0])];
                                    case 1:
                                        res = _a.sent();
                                        if (this_1.util.isSuccessResponse(res)) {
                                            ++success;
                                        }
                                        else {
                                            ++fail;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectList.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        //some case fail some case success
                        if (fail > 0 && success > 0) {
                            this.util.WarningDialog("ลบสำเร็จจำนวน: " + success + " Contact, ลบไม่สำเร็จจำนวน: " + fail + " Contact");
                        }
                        else if (fail == 0 && success == 0) {
                            this.util.ErrorDialog("ลบ Contact ไม่สำเร็จ");
                        }
                        else if (fail > 0 && success == 0) {
                            this.util.ErrorDialog("ลบ Contact ไม่สำเร็จ");
                        }
                        else {
                            $("#deleteModal").modal('hide');
                            this.util.SuccessDialog("ลบ Contact สำเร็จ");
                        }
                        //await this.search(true)
                        $('#tbContact').DataTable().clear().destroy();
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.smsChange = function () {
        var _this = this;
        var selectd = this.smsTemplate.filter(function (e) { return e.dpa_externalsmstemplateid == _this.selectedSms; });
        if (selectd != null && selectd.length > 0) {
            this.smsText = selectd[0].dpa_templatebodysms;
        }
        else {
            this.smsText = "";
        }
    };
    ContactComponent.prototype.emailChange = function () {
        var _this = this;
        var selectd = this.emailTemplate.filter(function (e) { return e.templateid == _this.selectedEmail; });
        if (selectd != null && selectd.length > 0) {
            this.emailText = selectd[0].body;
            $('#summernote').summernote('code', this.emailText);
            if (selectd[0].attachments != null && selectd[0].attachments.length > 0) {
                var att = selectd[0].attachments.map(function (a) { return a.filename; });
                this.attachments = att.join(" ,  ");
            }
            else {
                this.attachments = "";
            }
        }
        else {
            this.emailText = "";
            this.attachments = "";
        }
    };
    ContactComponent.prototype.onCheckAllChange = function () {
        $(".row-checker").prop("checked", this.isCheckedAll);
    };
    ContactComponent.prototype.getSelectedContact = function () {
        var thisTs = this;
        this.selectList = [];
        $('.row-checker:checkbox:checked').each(function () {
            var value = {
                contactId: $(this).val(),
                fullname: $(this).closest('tr').find('td.col-fullname')[0].innerHTML,
                tel: $(this).closest('tr').find('td.col-tel')[0].innerHTML,
                email: $(this).prop("name")
            };
            thisTs.selectList.push(value);
        });
    };
    ContactComponent.prototype.search = function (getAll) {
        if (getAll === void 0) { getAll = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filtered, para, telnumber, firstname, lastname, name_1, i, req, phone, firstname, lastname, phoneNo, req, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 14, , 15]);
                        filtered = [];
                        if (!getAll) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        $('#tbContact').DataTable().clear().destroy();
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact")];
                    case 1:
                        filtered = _a.sent();
                        this.contactList = filtered.filter(function (c) {
                            return c.statusreason == 1 || c.statusreason == "1";
                        });
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 13];
                    case 2:
                        para = "";
                        telnumber = "";
                        if (this.firstnameSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSearch;
                        }
                        if (this.lastnameSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSearch;
                        }
                        if (this.telephoneSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "telephoneno=" + this.telephoneSearch;
                            telnumber = this.telephoneSearch;
                        }
                        if (this.idcardSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "idcard=" + this.idcardSearch;
                        }
                        if (this.accountNoSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "accountno=" + this.accountNoSearch;
                        }
                        if (!(para.length > 0)) return [3 /*break*/, 12];
                        this.util.ShowWaiting(true);
                        $('#tbContact').DataTable().clear().destroy();
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 3:
                        filtered = _a.sent();
                        if (!(filtered != null && filtered.length > 0)) return [3 /*break*/, 4];
                        this.contactList = filtered.filter(function (c) {
                            return c.statusreason == 1 || c.statusreason == "1";
                        });
                        return [3 /*break*/, 11];
                    case 4:
                        if (!this.isCrisis) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.getDrosContact()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.getDAContact()];
                    case 6:
                        _a.sent();
                        if (!(this.contactDros != null && this.contactDros.CRM06 != null)) return [3 /*break*/, 8];
                        firstname = "";
                        lastname = "";
                        try {
                            name_1 = this.contactDros.CRM06.Name.split(" ");
                            if (name_1.length > 0) {
                                if (name_1.length == 1) {
                                    firstname = name_1[0];
                                }
                                else if (name_1.length == 2) {
                                    firstname = name_1[0];
                                    lastname = name_1[1];
                                }
                                else {
                                    for (i = 0; i < name_1.length - 1; i++) {
                                        firstname += " " + name_1[i];
                                    }
                                    firstname = firstname.trim();
                                    lastname = name_1[name_1.length - 1];
                                }
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_telephone: this.contactDros.CRM06.PhoneNo,
                            telephone1: telnumber,
                            emailaddress1: this.contactDros.CRM06.Email,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            this.search();
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.contactDa != null && this.contactDa.FirstName != null)) return [3 /*break*/, 10];
                        phone = this.contactDa.MobileNumber.split(",");
                        firstname = this.contactDa.FirstName;
                        lastname = this.contactDa.LastName;
                        phoneNo = "";
                        if (telnumber != null && telnumber.trim().length > 0) {
                            phoneNo = telnumber;
                        }
                        else {
                            if (phone.length > 0 && phone[0] != "N/A") {
                                phoneNo = phone[0];
                            }
                            else {
                                phoneNo = telnumber;
                            }
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_telephone: phoneNo,
                            telephone1: phoneNo,
                            emailaddress1: this.contactDa.EmailAddress,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            //this.router.navigate(["/customer/" + res.contactid])
                                            this.search();
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        console.log("ไม่พบข้อมูล");
                        this.util.WarningDialog("ไม่พบข้อมูล");
                        _a.label = 11;
                    case 11:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 13];
                    case 12:
                        this.util.WarningDialog("กรุณาระบุเงื่อนไขในการค้นหา");
                        _a.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.resetSearchCirteria = function () {
        this.firstnameSearch = "";
        this.lastnameSearch = "";
        this.telephoneSearch = "";
        this.idcardSearch = "";
        this.accountNoSearch = "";
    };
    ContactComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.tbCon.changes.subscribe(function (t) {
            _this.initTableCon();
        });
    };
    ContactComponent.prototype.ngForRendred = function () {
        console.log('NgFor is Rendered');
        if (this.dtCon == null) {
            this.initTableCon();
        }
    };
    ContactComponent.prototype.initTableCon = function () {
        var thisTs = this;
        $('#tbContact td:not(.checkbox-col)').click(function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    url = thisTs.util.baseUrl() + "/customer/" + $(this).parent('tr').find("input[type='checkbox']")[0].value;
                    window.open(url, '_blank');
                    return [2 /*return*/];
                });
            });
        });
        this.dtCon = $("#tbContact").DataTable({
            retrieve: true,
            'searching': false,
            "order": [],
            columnDefs: [{ orderable: false, targets: [0] }]
        });
    };
    ContactComponent.prototype.mainChange = function (num) {
        this.chkMain = num;
        this.chkName = num;
        this.chkLastname = num;
        this.chkDob = num;
        this.chkIdNo = num;
        this.chkEmail = num;
        this.chkTel = num;
    };
    ContactComponent.prototype.getDrosContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "CRM06=true";
                        if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
                            para += "&dpa_id=" + this.idcardSearch;
                        }
                        if (this.telephoneSearch != null && this.telephoneSearch.toString().trim().length > 0) {
                            para += "&telephoneno=" + this.telephoneSearch;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)]; //ค้น DROS
                    case 1:
                        _a.contactDros = _b.sent(); //ค้น DROS
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.getDAContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "";
                        if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
                            para += "IdNo=" + this.idcardSearch;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getDA", para)]; //ค้น DA
                    case 1:
                        _a.contactDa = _b.sent(); //ค้น DA
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.ngOnDestroy = function () {
        $('#summernote').summernote('destroy');
    };
    return ContactComponent;
}());
export { ContactComponent };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts.pre-build-optimizer.js